import axios from 'axios';

import {DataGridBulkActionsResponseBodySchema} from '../schemas/DataGridBulkActionsResponseBodySchema';
import type {
  SubmitBulkOperationResponseBody,
  SubmitFilteredRecordsBulkOperationRequestBody,
} from '../types/api/bulkOperations';
import {AXIOS_BASE_CONFIG} from './axiosConfig';
import type {ApiContext} from './types';

export function createBulkActionsApi(ctx: Pick<ApiContext, 'gridCode' | 'handleApiError'>) {
  const base = `/v6/data-grid/${encodeURIComponent(ctx.gridCode)}`;
  return {
    getBulkActions: () =>
      axios
        .get<unknown>(`${base}/bulk-action`, AXIOS_BASE_CONFIG)
        .then((response) => DataGridBulkActionsResponseBodySchema.parse(response.data))
        .catch((error: unknown) => {
          if (axios.isAxiosError(error) && error.response?.status === 404) {
            return undefined;
          }
          ctx.handleApiError(error);
          return undefined;
        }),
    submitFilteredBulkOperation: (body: SubmitFilteredRecordsBulkOperationRequestBody) =>
      axios
        .post<SubmitBulkOperationResponseBody>(`${base}/bulk-operation`, body, AXIOS_BASE_CONFIG)
        .then((response) => response.data),
  };
}
